import React, { useEffect, useState } from "react";
import MenuAdmin from "./menuadmin";
import Box from "@mui/joy/Box";
import Card from "@mui/joy/Card";
import CardOverflow from "@mui/joy/CardOverflow";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import CardContent from "@mui/joy/CardContent";
import HandshakeIcon from "@mui/icons-material/Handshake";
import BlockIcon from "@mui/icons-material/Block";
import IconButton from "@mui/joy/IconButton";
import Grid from "@mui/joy/Grid";
import Alert from "@mui/joy/Alert";
import axios from "axios";

export default function ModerarUsuarios() {
  let [usuarios, setUsuarios] = React.useState();
  let [posicion, setPosicion] = React.useState(0);
  let [popup, setPopup] = React.useState({
    activado: false,
    contenido: "",
  });

  /* CALCULAR EDAD*/

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    const edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      return edad - 1;
    }
    return edad;
  };

  /* CALCULAR EDAD*/

  async function desactivarUsuario() {
    try {
      let seleccionado = usuarios[posicion];
      let token = localStorage.getItem("token");
      let enviarInformacion = await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/api/desactivar-usuario`,
        { seleccionado },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(enviarInformacion);
      setPopup({
        activado: true,
        contenido: `El usuario ${seleccionado.nombre} ha sido desactivado`,
      });

      setTimeout(() => {
        setPopup({ activado: false });
      }, 2000);
    } catch (err) {
      console.log("Tenemos un error al Banear al usuario: " + err);
    }
  }

  async function aprobarUsuario() {
    try {
      let seleccionado = usuarios[posicion];
      let token = localStorage.getItem("token");
      let enviarInformacion = await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/api/aprobar-usuario`,
        { seleccionado },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(enviarInformacion);
      setPopup({
        activado: true,
        contenido: `El usuario ${seleccionado.nombre} ha sido aprobado`,
      });

      setTimeout(() => {
        setPopup({ activado: false });
      }, 2000);
    } catch (err) {
      console.log("Tenemos un error al Aprobar al usuario: " + err);
    }
  }

  useEffect(() => {
    try {
      let getInformacion = async () => {
        /* OBTENER BEARER TOKEN */
        let token = localStorage.getItem("token");

        /* OBTENER BEARER TOKEN */
        let getUsuarios = await axios.get(
          `${process.env.REACT_APP_FRONTEND_URL}/api/moderar-usuarios`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log(getUsuarios.data.rows);
        setUsuarios(getUsuarios.data.rows);
      };
      getInformacion();
    } catch (err) {
      console.log("Tenemos el siguiente error al obtener los usuarios: " + err);
    }
  }, []);

  let Tarjeta = ({
    imagen,
    nombre,
    fecha_de_nacimiento,
    descripcion_perfil,
    correo,
    ciudad,
    pais,
    actividades,
    intereses,
  }) => {
    return (
      <Box
        sx={{
          display: "flex",
          height: "50vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card sx={{ width: 300 }}>
          <CardOverflow sx={{ cursor: "pointer" }}>
            <AspectRatio ratio={"21/9"}>
              <img
                src={`${process.env.REACT_APP_DOSPACES}/uploads/${imagen}`}
                loading="lazy"
              />
            </AspectRatio>
            <Chip size="sm" sx={{ position: "absolute", bottom: 5, right: 5 }}>
              {ciudad}, {pais}
            </Chip>
          </CardOverflow>

          <CardContent>
            <Typography level="title-md">
              {nombre}, {calcularEdad(fecha_de_nacimiento)} años
            </Typography>
            <Typography level="body-xs">{correo}</Typography>
            <Grid container spacing={1}>
              {actividades.map((x) => {
                return (
                  <Grid key={x.id}>
                    <Chip size="sm" sx={{ backgroundColor: "#EFE3C2" }}>
                      {x}
                    </Chip>
                  </Grid>
                );
              })}
            </Grid>
            <Typography level="body-xs">{intereses}</Typography>
          </CardContent>
          <CardContent>
            <Typography level="body-xs">{descripcion_perfil}</Typography>
          </CardContent>

          <CardContent sx={{ marginTop: "1rem" }}>
            <Grid container spacing={2} justifyContent="space-between">
              <Grid>
                <IconButton
                  sx={{ "&:hover": { backgroundColor: "transparent" } }}
                >
                  <BlockIcon
                    sx={{ fontSize: 40, color: "#D32F2F" }}
                    onClick={() => {
                      console.log("Baneado");
                      desactivarUsuario();
                      setPosicion(posicion + 1);
                    }}
                  />
                </IconButton>
              </Grid>
              <Grid>
                <IconButton
                  sx={{ "&:hover": { backgroundColor: "transparent" } }}
                >
                  <HandshakeIcon
                    sx={{ fontSize: 40, color: "#123524" }}
                    onClick={() => {
                      console.log("Aprobado");
                      aprobarUsuario();
                      setPosicion(posicion + 1);
                    }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    );
  };

  let mostrarUsuarios = () => {
    return (
      <Box>
        {usuarios.length > posicion ? (
          <Tarjeta
            imagen={usuarios[posicion].foto_de_perfil}
            nombre={usuarios[posicion].nombre}
            fecha_de_nacimiento={usuarios[posicion].fecha_de_nacimiento}
            correo={usuarios[posicion].correo}
            pais={usuarios[posicion].pais}
            ciudad={usuarios[posicion].ciudad}
            actividades={usuarios[posicion].actividades}
            intereses={usuarios[posicion].intereses}
            descripcion_perfil={usuarios[posicion].descripcion_perfil}
          />
        ) : (
          <Typography level="body-xs">No hay usuarios para Moderar</Typography>
        )}
      </Box>
    );
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          flexGrow: 1,
          marginLeft: 8,
        }}
      >
        <Box
          sx={{
            width: "90vw",
            height: "90vh",
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {popup.activado ? (
            <Alert variant="soft" className="notificacion" color="success">
              {popup.contenido}
            </Alert>
          ) : null}

          <Box>
            {usuarios ? (
              mostrarUsuarios()
            ) : (
              <Typography level="body-xs">
                No hay usuarios para Moderar
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
      <MenuAdmin />
    </Box>
  );
}
